<span *ngIf="isLoading; else statusIcon" class="spinner-border spinner-border-sm" role="status"
      aria-hidden="true"></span>
<ng-template #statusIcon>
  <em class="bi" [class.bi-check-lg]="isValid" [class.bi-question-lg]="!isValid"></em>
</ng-template>
